var map = {
	"./airpods.png": "f4e8",
	"./amanali-regalo.png": "a790",
	"./apple-vision-pro.png": "86de",
	"./apple-watch.png": "71bb",
	"./artboard-1-copia-2-100_upscayl_4x_realesrgan-x4plus.png": "1af6",
	"./barra.png": "7c12",
	"./bolsa-taylormade.png": "3a30",
	"./bpc.png": "6388",
	"./btn-sortear-vacio.png": "ccc7",
	"./btn-sortear.png": "31c5",
	"./cibc.png": "295f",
	"./foursome-tepeji.png": "e42c",
	"./hostal-de-la-luz-regalo.png": "f4a9",
	"./logo.png": "f826",
	"./nintendo.png": "a89f",
	"./nintendo2.png": "53f2",
	"./pantalla.png": "8aaa",
	"./playstation.png": "ba7e",
	"./regalo2.png": "2148",
	"./sand-taylormade.png": "fdc7",
	"./whisky.png": "ab05",
	"./xbox.png": "4ddc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7e45";